var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaduceus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235.67 309.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4700ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.72,23.62a2.1,2.1,0,0,1-.13.26v0C113.64,23.78,113.68,23.7,113.72,23.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.59,23.86v0a2.1,2.1,0,0,0,.13-.26C113.68,23.7,113.64,23.78,113.59,23.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.59,49.25,211.47,25.39a7.8,7.8,0,0,0-4.38-2.53l-.37-.07-36.35-6.93a11.17,11.17,0,0,0-3.32-5A8.3,8.3,0,0,0,163.3,9l-.23,0L117,.17h0a8.46,8.46,0,0,0-3.25,0l-39.87,7c-7.2,1.32-10.73,8.45-10.48,14.82l.77,20.74-31.62-6h0a8.88,8.88,0,0,0-9,4.17l-21,32C-.46,77.28-1.39,84,3.1,89.09L68.52,162.9l4.72,126.2c.2,5.94,3.29,10.3,7.9,11.13h0l46.26,8.81.08,0a9.26,9.26,0,0,0,1.72.15,11.45,11.45,0,0,0,2.18-.21l26.3-4.65c6.33-1.08,10.18-7.77,10.25-13.61l1.49-127.93,63.75-97.21C236.7,60.3,236.45,53.56,232.59,49.25ZM68.75,17.87l41.51,7.9a17.27,17.27,0,0,0-.56,5L111.51,80,83.22,48a7.8,7.8,0,0,0-4.39-2.54l-.39-.08-9.37-1.78-.81-21.88A11.74,11.74,0,0,1,68.75,17.87ZM6.6,75.54l21-32a4,4,0,0,1,3.92-2L70.38,48.9c-.19.24-.37.48-.54.74l-21,32a15.27,15.27,0,0,0-2,4.66L5.3,78.41A10.26,10.26,0,0,1,6.6,75.54Zm65.65,84.1L6.81,85.8a6.9,6.9,0,0,1-1.4-2.33L46.48,91.3a11.91,11.91,0,0,0,3,6.62L110.69,167Zm9.81,135.73c-3.46-.6-3.84-5.47-3.87-6.45l-4.64-124,41.4,7.89,4.68,125.11a15.61,15.61,0,0,0,.88,4.77ZM120.18,15.94a11.93,11.93,0,0,0-7.82,5.19L71.63,13.37a6.8,6.8,0,0,1,3-1.39l39.87-7A3.93,3.93,0,0,1,116,5l31.9,6.08Zm77.91,11.11L170.55,69,171,21l27.61,5.26C198.45,26.53,198.26,26.79,198.09,27.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.3,9h0l-.23,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaduceus);
export default __webpack_public_path__ + "static/media/caduceus.0a19f75ff34cf0287b96b143cb525394.svg";
export { ForwardRef as ReactComponent };